// 261005 F36 — "id job đang theo dõi" của một thành phần, có NHẬN NUÔI job BE báo đang chạy (sau tải lại / đổi chặng state cục bộ mất).
// KHÔNG import antd. Job đã kết thúc ở phiên này (`release`) không bị nhận nuôi lại dù workbench chưa kịp làm mới (poll 5s).
import { useCallback, useEffect, useRef, useState } from 'react';

export interface AdoptedJobId {
  jobId: string | null;
  /** Bắt đầu theo dõi một job do chính thành phần này khởi động. */
  setJobId: (id: string | null) => void;
  /** Kết thúc theo dõi (xong / lỗi / bỏ): nhớ id để không nhận nuôi lại. */
  release: () => void;
}

export const useAdoptedJobId = (scopeKey: string, candidate: string | null): AdoptedJobId => {
  const [jobId, setJobIdState] = useState<string | null>(null);
  const idRef = useRef<string | null>(null);
  const done = useRef<Set<string>>(new Set());

  const setJobId = useCallback((id: string | null) => { idRef.current = id; setJobIdState(id); }, []);
  const release = useCallback(() => {
    if (idRef.current) done.current.add(idRef.current);
    idRef.current = null;
    setJobIdState(null);
  }, []);

  useEffect(() => { idRef.current = null; done.current = new Set(); setJobIdState(null); }, [scopeKey]);
  useEffect(() => {
    if (!jobId && candidate && !done.current.has(candidate)) { idRef.current = candidate; setJobIdState(candidate); }
  }, [jobId, candidate]);

  return { jobId, setJobId, release };
};
